var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"official-app",attrs:{"id":"app"}},[_c('header-comp',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/special-column'),expression:"$route.path != '/special-column'"}],staticClass:"pc-comp"}),_c('media-header',{staticClass:"mobile-comp"}),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"pervasive-bag",class:{
        'party-building-bag': _vm.$route.query.title == '器检党建',
        'special-column-bag': _vm.$route.path == '/special-column'
      }},[_c('div',{staticClass:"version-center mt16"},[_c('keep-alive',{attrs:{"include":[
            'home',
            'institutionalOverview',
            'officeHall',
            'specialColumn'
          ]}},[_c('router-view')],1)],1),_c('friendship-link')],1)]),_c('footer-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }